import { ItineraryReferenceInfoObj } from '../FlyAPICommon/itinerary-reference-info-model'
import { PricingInfoObj } from '../FlyAPICommon/pricing-info-model'

/**
 * Object to contain express deal response object
 * @dependency {ItineraryReferenceInfoObj, PricingInfoObj}
 */
class ExpressDealInfoObj {
  constructor() {
    this.isExpressDeal = true
    this.id = ''
    this.candidateKey = ''
    this.itineraryReferenceInfo = new ItineraryReferenceInfoObj()
    this.pricingInfo = new PricingInfoObj()
    this.slice = []
    this.acceptedCreditCards = []
    this.lapInfantsAllowed = true
    this.passportRequired = false
    this.sameDayDepartHoursBeforeTravel = 0
    this.openJaw = false
    this.isSaleEligible = false
  }

  getId() {
    return this.id
  }

  setId(id) {
    this.id = id
  }

  getCandidateKey() {
    return this.candidateKey
  }

  setCandidateKey(candidateKey) {
    this.candidateKey = candidateKey
  }

  getItineraryReferenceInfo() {
    return this.itineraryReferenceInfo
  }

  setItineraryReferenceInfo(itineraryReferenceInfo) {
    this.itineraryReferenceInfo = itineraryReferenceInfo
  }

  getPricingInfo() {
    return this.pricingInfo
  }

  setPricingInfo(pricingInfo) {
    this.pricingInfo = pricingInfo
  }

  getSlice() {
    return this.slice
  }

  addSlice(slice) {
    this.slice.push(slice)
  }

  getSameDayDepartHoursBeforeTravel() {
    return this.sameDayDepartHoursBeforeTravel
  }

  setSameDayDepartHoursBeforeTravel(sameDayDepartMinsBeforeTravel) {
    if (sameDayDepartMinsBeforeTravel) {
      this.sameDayDepartHoursBeforeTravel = Math.floor(
        sameDayDepartMinsBeforeTravel / 60
      )
    }
  }

  isOpenJaw() {
    return this.openJaw
  }

  setOpenJaw(openJaw) {
    this.openJaw = !!openJaw
  }

  getIsSaleEligible() {
    return this.isSaleEligible
  }

  setIsSaleEligible(isSaleEligible) {
    this.isSaleEligible = isSaleEligible
  }
}

export { ExpressDealInfoObj }
